import { push } from 'react-router-redux';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../actions/standardActions';
import { storeClear } from '../actions/storeActions';

// api
import tokenAPI from '../sources/api/tokenAPI';
import userAPI from '../sources/api/userAPI';

// constants
import { CURRENT_USER_FETCH } from '../constants/currentUserTypes';
import { SESSION_CREATE, SESSION_DESTROY } from '../constants/sessionTypes';
import { TOKEN_CREATE } from '../constants/tokenTypes';

// lib
import httpSaga from '../lib/httpSaga';

export function* sessionCreate(action) {
  const payload = action.payload;
  const email = payload.email;
  const password = payload.password;

  try {
    yield* httpSaga(TOKEN_CREATE, call(tokenAPI.create, email, password));

    const response = yield* httpSaga(CURRENT_USER_FETCH, call(userAPI.fetchSelf));
    const user = response.body;

    let uri;

    switch (user.type) {
      case 'manager':
        uri = '/managers/calendar';
        break;
      case 'rep':
        uri = '/reps/books';
        break;
      default:
        uri = '/login';
        break;
    }

    yield put(push(uri));
  } catch (err) {
    yield put(error(TOKEN_CREATE, err));
  } finally {
    yield put(doneIndicator(TOKEN_CREATE));
  }
}

function* destroyFreshChat() {
  try {
    if (window.fcWidget && typeof window.fcWidget.destroy === 'function') {
      yield window.fcWidget.destroy();
    }
  } catch (err) {
    // FreshChat might not be loaded, ignore the error
  }
}

export function* sessionDestroy() {
  try {
    yield call(tokenAPI.blacklist);
  } catch (err) {
    // DO NOTHING
  } finally {
    yield put(storeClear());
    yield call(destroyFreshChat);
    yield put(push('/login'));
  }
}

export function* watchSessionCreate() {
  yield takeEvery(SESSION_CREATE, sessionCreate);
}

export function* watchSessionDestroy() {
  yield takeEvery(SESSION_DESTROY, sessionDestroy);
}

export default function* root() {
  yield all([
    fork(watchSessionCreate),
    fork(watchSessionDestroy)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/session.js